module.exports = __webpack_public_path__ + "ChampCertifiedDoc___3PJP9.svg";